import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class RefreshSelectionOptionService {
    refreshData = new Subject<any>();
    refreshTableData = new Subject<any>();

    refreshSelectionOption() {
        this.refreshData.next();
    }

    refreshTableDataScrollbar() {
        this.refreshTableData.next();
    }
}
